import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../config/api";
import {
    Typography,
    Spin,
} from "antd";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const { Text } = Typography;

const MarketplaceInquiryResponsesList = ({ inquiryUuid }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [responses, setResponses] = useState([]);
    const { inquiryUuid: routeInquiryUuid } = useParams();

    const finalInquiryUuid = inquiryUuid || routeInquiryUuid;

    const inquiryResponseCreated = useSelector(
        (state) => state.inquiryResponseCreated
    );
    const inquiryResponseDeleted = useSelector(
        (state) => state.inquiryResponseDeleted
    );

    const fetchResponses = () => {
        if (!finalInquiryUuid) return;

        const apiUrl = `${api.host}/inquiries/${finalInquiryUuid}/responses/public`;

        setLoading(true);
        fetch(apiUrl)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch inquiry responses");
                }
                return response.json();
            })
            .then((data) => {
                setResponses(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching responses:", error);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchResponses();
    }, [finalInquiryUuid, inquiryResponseCreated, inquiryResponseDeleted]);

    return (
        <Spin spinning={loading}>
            <div style={{ textAlign: "center", padding: "20px" }}>
                {responses.length > 0 ? (
                    <div>
                        <div style={{ fontSize: "32px", marginBottom: "12px" }}>👥</div>
                        <Text strong style={{ fontSize: "18px", color: "#2c3e50" }}>
                            {responses.length} {responses.length === 1 ? t('marketplace.responses.personInterested') : t('marketplace.responses.peopleInterested')}
                        </Text>
                        <div style={{ marginTop: "8px" }}>
                            <Text style={{ color: "#6c757d", fontSize: "14px" }}>
                                {t('marketplace.responses.submitOfferToJoin')}
                            </Text>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div style={{ fontSize: "32px", marginBottom: "12px" }}>💼</div>
                        <Text style={{ color: "#6c757d", fontSize: "16px" }}>
                            {t('marketplace.responses.noOffers')} 
                        </Text>
                        <div style={{ marginTop: "8px" }}>
                            <Link to="/transactions" style={{ color: "#667eea", fontWeight: "500" }}>
                                {t('marketplace.responses.addFirst')}
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </Spin>
    );
};

export default MarketplaceInquiryResponsesList;